import React from "react";
//iconos
import ComputerIcon from "@mui/icons-material/Computer";
import CalculateIcon from "@mui/icons-material/Calculate";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import ReceiptIcon from "@mui/icons-material/Receipt";
import AddToQueueIcon from "@mui/icons-material/AddToQueue";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import PivotTableChartIcon from "@mui/icons-material/PivotTableChart";
import ControlCameraIcon from "@mui/icons-material/ControlCamera";
import BlenderIcon from "@mui/icons-material/Blender";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import SellIcon from "@mui/icons-material/Sell";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import PageviewIcon from "@mui/icons-material/Pageview";
import BalanceIcon from "@mui/icons-material/Balance";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import MonetizationOn from "@mui/icons-material/MonetizationOn";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

export const IconosAside = ({ icono }) => {
  switch (Number(icono)) {
    case 1:
      return <ComputerIcon className="tc-blueN" />;
    case 2:
      return <CalculateIcon className="tc-darkblueN" />;
    case 3:
      return <AccountBalanceWalletIcon className="tc-lightblueN" />;
    case 4:
      return <PeopleAltIcon className="tc-purpleN" />;
    case 5:
      return <ReceiptIcon className="tc-darkorangeN" />;
    case 6:
      return <AddToQueueIcon className="tc-lightorangeN" />;
    case 7:
      return <AgricultureIcon className="tc-coffeN" />;
    case 8:
      return <QueryStatsIcon className="tc-greenN" />;
    case 9:
      return <PivotTableChartIcon className="tc-yellowN" />;
    case 10:
      return <SellIcon className="tc-lilaN" />;
    case 11:
      return <ControlCameraIcon className="tc-darkredN" />;
    case 12:
      return <PriceCheckIcon className="tc-coffeN" />;
    case 13:
      return <PageviewIcon className="tc-darkorangeN" />;
    case 14:
      return <BlenderIcon className="tc-darkblueN" />;
    case 15:
      return <Diversity3Icon className="tc-purpleN" />;
    case 16:
      return <BalanceIcon />;
    case 17:
      return <CreditCardIcon />;
    case 18:
      return <MonetizationOn />;
    case 19:
      return <WhatsAppIcon />;
    default:
      return <div>Sin datos</div>;
  }
};
